module.exports = __webpack_public_path__ + "static/media/registerP.6556f43f.jpg";